export class xLoginResponse {
  public UserName: string;
  public UserType: number;
  public ActorCode: number;
  public DisplayName: string;
  public Email: string;
  public MobileNo: string;
  public ActorImageFile: string;
  public FileExtension: string;
  public AuthGenKEY: string;
  public LocationCode: number;
  public LangCode: number;
  public TimeZoneCode: number;
  public EmpFacilityCode: number;
  public EmpFormattedCode: string;
  public FacilityActorCode: number;
  public CompanyCode: number;
  public TimeZoneUtcDiff: number;
  public TimeZoneDisplayName: string;
  public EmployeeCode: number;
  public ActorType: number;
  public UserId: string;
  public RoleName: string;
  public LastLoginDate: Date;
  public FacilityName: string;
}
